// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__19e5A","amount":"Amount_amount__2Oq9f","tip":"Amount_tip__WY8gQ","tipHeader":"Amount_tipHeader__2R-pu","tipsWrap":"Amount_tipsWrap__33wHp"};